export default "__VITE_ASSET__899b04ea__"